<template>
    <settings-control label="Line Height">
        <dropdown
            theme="minimalistic"
            placeholder="Select Size"
            :options="options"
            :value="lineHeight"
            native
            @input="onInput"
        />
    </settings-control>
</template>

<script>
import SettingsControl from '@/components/settings/shared/settings-control';
import { tailwindConfig } from '@/data/tailwind';

const configValues = tailwindConfig.theme.lineHeight;

export default {
    name: 'settings-control-line-height',
    components: { SettingsControl },

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            lineHeight: this.value,
        };
    },

    computed: {
        options() {
            const defaultOption = { text: 'Default', value: '' };
            const heightOptions = Object.keys(configValues).map(key => ({ text: configValues[key], value: configValues[key] }));

            return [defaultOption].concat(heightOptions);
        },
    },

    watch: {
        value(newVal) {
            this.lineHeight = newVal;
        },
    },

    methods: {
        onInput(value) {
            this.lineHeight = value;

            this.$emit('input', {
                tailwindDefinitionProp: 'lineHeight',
                value,
            });
        },
    },
};
</script>
